import React from 'react';
import './CommentsPanel.scss';
import { comment } from '@sp-types/FutureOrderType';
import { TrashIcon } from '../../../../../pages/Dashboard/dashboard-components/DashboardNotifications/components/NotificationIcons';
interface Props {
  comments: comment[];
  onAddComment: (_text: string) => void;
  deleteComments: (_comments: comment[]) => void;
  disabled?: boolean;
}
export const CommentsPanel: React.FC<Props> = ({
  comments,
  onAddComment,
  deleteComments,
  disabled = false,
}): React.ReactNode => {
  const [commentText, setCommentText] = React.useState('');
  const dateOpts: any = { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false };
  const addComment = () => {
    if (commentText) {
      onAddComment(commentText);
      setCommentText('');
    }
  };

  return (
    <div className="flex flex-col gap-2 flex-1 justify-end">
      <div className="overflow-y-scroll flex-1 gap-2 max-h-[22rem] border-b-gray-125">
        {comments.map((comment, i) => (
          <div key={i} className="border-b border-b-gray-200 gap-2 py-2 commentCss">
            <div className="text-gray-400 text-sm justify-between flex">
              {comment.addedOn.toDate().toLocaleDateString('en-US', dateOpts)}
              {!disabled && (
                <button onClick={() => deleteComments([comment])} className="text-blue-600">
                  <TrashIcon iconColor="#6571FF" />
                </button>
              )}
            </div>
            <div>{comment.text}</div>
          </div>
        ))}
      </div>
      {comments.length > 0 && !disabled && (
        <div className="border-t border-t-gray-125 text-sm text-blue-600 p-2">
          <button onClick={() => deleteComments(comments)}>Clear all</button>
        </div>
      )}
      <div className="flex gap-2 justify-between text-sm">
        <input
          type="text"
          disabled={disabled}
          value={commentText}
          onChange={({ target }) => setCommentText(target.value)}
          onKeyUp={({ code }) => (code.includes('Enter') ? addComment() : null)}
          className="w-full border p-1 rounded focus:outline-blue-600"
        />
        <button onClick={addComment} disabled={disabled}>
          <img src="/assets/icons/blue-flat/send.svg" alt="send" />
        </button>
      </div>
    </div>
  );
};
